import React from 'react'
import { format } from 'date-fns'
import pt from 'date-fns/locale/pt-BR'

import { Tooltip, Typography } from '@telavita-core/react-design-kit'

import {
  Container,
  Bars,
  BarItem,
  Label,
  TooltipContainer,
  Circle,
} from './styles'

interface VerticalBarProps {
  date: string
  firstBarValue: number
  secondBarValue: number
}

interface CustomTooltipProps {
  text: JSX.Element
  circleColor: string
}

interface LabelsProps {
  date: string
}

export function VerticalBar({
  date,
  firstBarValue,
  secondBarValue,
}: VerticalBarProps): JSX.Element {

  const firstBarValueText = firstBarValue === 1 
    ? <><strong>{firstBarValue} horário</strong><br />disponibilizado</>
    : <><strong>{firstBarValue} horários</strong><br />disponibilizados</> 

  const secondBarValueText = secondBarValue === 1
    ? <><strong>{secondBarValue} agendamento</strong><br />recebido</>
    : <><strong>{secondBarValue} agendamentos</strong><br />recebidos</>

  return (
    <Container>
      <Bars>
        <Tooltip
          content={
            <CustomTooltip 
              circleColor='#d5d5d5'
              text={firstBarValueText}
            />
          }
          theme='light'
        >
          <BarItem 
            backgroundColor='#d5d5d5'
            height={firstBarValue}
          />
        </Tooltip>

        <Tooltip
          content={
            <CustomTooltip
              circleColor='#1f35b5'
              text={secondBarValueText}
            />
          }
          theme='light'
        >
          <BarItem 
            backgroundColor='#1f35b5'
            height={secondBarValue}
          />
        </Tooltip>
      </Bars>

      <Labels 
        date={date}
      />
      
    </Container>
  )
}

function CustomTooltip({
  text,
  circleColor,
}: CustomTooltipProps): JSX.Element {
  return (
    <TooltipContainer>
      <Circle 
        color={circleColor}
      />
      <Typography
        variant='content3'
      >
        {text}
      </Typography>
    </TooltipContainer>
  )
}

function Labels({
  date,
}: LabelsProps): JSX.Element {
  return (
    <>
      <Label
        weight='bolder'
        color='#4b4b4b'
      >
        {format(new Date(date), 'iiiiii', { locale: pt })}
      </Label>
      <Label
        weight='normal'
        color='#4b4b4b'
      >
        {format(new Date(date), 'dd/MM', { locale: pt })}
      </Label>
      <Label
        weight='normal'
        color='#adadad'
      >
        {format(new Date(date), 'yy', { locale: pt })}
      </Label>
    </>
  )
}